export function objectGroupBy<T>(object: Record<string, T>, getKey: (t: T) => string): Record<string, Array<T>> {
  let ret: Record<string, Array<T>> = {};

  Object.entries(object).forEach(([_, value]) => {
    const k = getKey(value);
    const t = ret[k];

    if (Array.isArray(t)) {
      ret[k] = [...t, value];
    } else {
      ret[k] = [value];
    }
  });

  return ret;
}

export function arrayGroupByTransform<T, R>(
  arr: Array<T>,
  getKey: (t: T) => string,
  transformR: (t: T) => R,
): Record<string, Array<R>> {
  let ret: Record<string, Array<R>> = {};

  arr.forEach(valueT => {
    const valueR = transformR(valueT);
    const k = getKey(valueT);
    const t = ret[k];

    if (Array.isArray(t)) {
      ret[k] = [...t, valueR];
    } else {
      ret[k] = [valueR];
    }
  });

  return ret;
}
